import ApiClient from "@/domain/core/utils/apiClient";
import client_core from "@/services/clients/client_core";
const client = new ApiClient(client_core)

const endpoints = {
    timezones: '/dashboard/v2/core/timezones/',
    currencies: '/dashboard/v2/core/currencies/',
    countries: '/dashboard/v2/core/countries/',
    recognition_classes: '/dashboard/v2/core/recognition_class/',
    cluster_sizes: '/dashboard/v2/core/cluster_size/',
    categories: '/dashboard/v2/core/category/',
    codecs: '/dashboard/v2/core/codec/',
    checkin_stay_mode: '/dashboard/v2/core/checkin_stay_mode/',
    regions: '/dashboard/v2/core/region/',
    orderStatus: '/dashboard/v2/core/order_status/',
    paymentMethods: '/dashboard/v2/core/payment_methods/?pica_service_id={picaServiceId}',
    favouriteEligibility: '/dashboard/v2/core/favourite_eligibility/?gallery_id={galleryId}',
    anonymizeMode: '/dashboard/v2/core/anonymize_mode/',
    shareMode: '/dashboard/v2/core/share_mode/',
    experienceType: '/dashboard/v2/core/experience_type/',
    purchaseTime: '/dashboard/v2/core/purchase_time/',
    displayTime: '/dashboard/v2/core/display_time/',
    hdStorageTypes: '/dashboard/v2/core/hd_storage_type/',
    hdServingTypes: '/dashboard/v2/core/hd_serving_type/',
    sdServingTypes: '/dashboard/v2/core/sd_serving_type/',
    processingPriority: '/dashboard/v2/core/processing_priority/',
    subGalleryDisplayTypes: '/dashboard/v2/core/sub_gallery_display_type/',
    compactDisplayTypes: '/dashboard/v2/core/compact_display_type/',
    expandedDisplayTypes: '/dashboard/v2/core/expanded_display_type/',
    processingPipelines: '/dashboard/v2/core/processing_pipeline/',
    refundTypes: '/dashboard/v2/core/refund_type/',
    chargebackTypes: '/dashboard/v2/core/chargeback_type/',
}

export default {
    async fetchTimezones() {
        return await client.get(endpoints.timezones)
    },
    async fetchCurrencies() {
        return await client.get(endpoints.currencies)
    },
    async fetchCountries() {
        return await client.get(endpoints.countries)
    },
    async fetchRecognitionClasses() {
        return await client.get(endpoints.recognition_classes)
    },
    async fetchClusterSizes() {
        return await client.get(endpoints.cluster_sizes)
    },
    async fetchCategories() {
        return await client.get(endpoints.categories)
    },
    async fetchCodecs() {
        return await client.get(endpoints.codecs)
    },
    async fetchCheckinStayMode() {
        return await client.get(endpoints.checkin_stay_mode)
    },
    async fetchRegions() {
        return await client.get(endpoints.regions)
    },
    async fetchOrderStatus() {
        return await client.get(endpoints.orderStatus)
    },
    async fetchPaymentMethods(picaServiceId) {
        return await client.get(endpoints.paymentMethods.replace('{picaServiceId}',picaServiceId))
    },
    async fetchFavouriteEligibility(galleryId) {
        return await client.get(endpoints.favouriteEligibility.replace('{galleryId}',galleryId))
    },
    async fetchAnonymizeMode() {
        return await client.get(endpoints.anonymizeMode)
    },
    async fetchShareMode() {
        return await client.get(endpoints.shareMode)
    },
    async fetchExperienceType() {
        return await client.get(endpoints.experienceType)
    },
    async fetchPurchaseTime() {
        return await client.get(endpoints.purchaseTime)
    },
    async fetchDisplayTime() {
        return await client.get(endpoints.displayTime)
    },
    async fetchHdStorageTypes() {
        return await client.get(endpoints.hdStorageTypes)
    },
    async fetchHdServingTypes() {
        return await client.get(endpoints.hdServingTypes)
    },
    async fetchSdServingTypes() {
        return await client.get(endpoints.sdServingTypes)
    },
    async fetchProcessingPriority() {
        return await client.get(endpoints.processingPriority)
    },
    async fetchSubGalleryDisplayTypes() {
        return await client.get(endpoints.subGalleryDisplayTypes)
    },
    async fetchCompactDisplayTypes() {
        return await client.get(endpoints.compactDisplayTypes)
    },
    async fetchExpandedDisplayTypes() {
        return await client.get(endpoints.expandedDisplayTypes)
    },
    async fetchProcessingPipelines() {
        return await client.get(endpoints.processingPipelines)
    },
    async fetchRefundTypes() {
        return await client.get(endpoints.refundTypes)
    },
    async fetchChargebackTypes() {
        return await client.get(endpoints.chargebackTypes)
    },
}
